import { render, staticRenderFns } from "./FoodBeverage.vue?vue&type=template&id=bbbc6066&scoped=true&"
import script from "./FoodBeverage.vue?vue&type=script&lang=js&"
export * from "./FoodBeverage.vue?vue&type=script&lang=js&"
import style0 from "./FoodBeverage.vue?vue&type=style&index=0&id=bbbc6066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbc6066",
  null
  
)

export default component.exports